// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"68":"views-users","459":"layouts-default-index","730":"views-report","821":"views-institutions","843":"views-gameGroup"}[chunkId] || chunkId) + "." + {"68":"6c0155c5","197":"5741adab","459":"096331cd","674":"15e80099","730":"882658c4","821":"fca1f64a","843":"bae92482"}[chunkId] + ".js";
};